import { stringify } from "querystring";
import { AssetInfoTypes, Configuration, IAssetProvider } from "threngine";

export enum SceneConfigAppendMode {
  Front = "front",
  Back = "back"
}

export class SceneConfigEditor {

  public config:Configuration;

  public constructor(
    config:Configuration,
    private assetProvider:IAssetProvider
  ) {
    // Make a deep copy of the config before editing it.
    this.config = JSON.parse(JSON.stringify(config));
  }

  public replaceVisibilityGroupByName(name:string, replacementName:string):void {
    const vgSrc = this.config.visibility_groups.find(vg => vg.name == replacementName);
    const vgDst = this.config.visibility_groups.find(vg => vg.name == name);

    vgDst.grouping_ids = vgSrc.grouping_ids.slice();
  }

  public addMaterialToMaterialGroupByName(
    materialGroupName:string,
    materialName:string,
    appendMode:SceneConfigAppendMode
  ):void {
    const materialGroup = this.config.material_groups.find(mg => mg.name == materialGroupName);

    const material = this.assetProvider.getAssets().find(
      a => a.infoType == AssetInfoTypes.Material && a.info.name == materialName);

    if (appendMode == SceneConfigAppendMode.Back) {
      materialGroup.material_ids.push(material.id);
    } else {
      materialGroup.material_ids.unshift(material.id);
    }
  }

  public setMaterialGroupDefaultByName(
    materialGroupName:string,
    materialName:string
  ):void {
    const materialGroup = this.config.material_groups.find(mg => mg.name == materialGroupName);
    if (!materialGroup) {
      console.error(`SceneConfigEditor: cannot find material group: ${materialGroupName}`);
      return;
    }

    const materialGroupDefault = this.config.default_state.material_groups.find(mg => mg.id == materialGroup.id);
    if (!materialGroupDefault) {
      console.error(`SceneConfigEditor: cannot find material group default: ${materialGroupName}`);
      return;
    }
  
    const material = this.assetProvider.getAssets().find(
      a => a.infoType == AssetInfoTypes.Material && a.info.name == materialName);


    if (!material) {
      console.error(`SceneConfigEditor: cannot find material: ${materialName}`);
      return;
    }

    materialGroupDefault.material_id = material.id;
  }
}